import { euro } from '../../core/format/currency';
import { kuurPriceProblem, kuurSaving } from '../../core/rules/kuur';
type Props = {
  sessions: number;
  kuurPrice: number;
  singlePrice: number | null;
};

/** Onder de kuurprijs: wat de klant bespaart, of waarom de prijs niet klopt. Het aantal sessies is per behandeling vrij (2 tot het maximum). */
export function KuurPriceNote({
  sessions,
  kuurPrice,
  singlePrice
}: Props) {
  if (!(kuurPrice > 0)) return null;
  const problem = kuurPriceProblem(sessions, kuurPrice, singlePrice);
  const saving = kuurSaving(sessions, kuurPrice, singlePrice);
  return <p role={problem ? 'alert' : undefined} className={`text-[13px] sm:col-span-2 ${problem ? 'text-clay' : 'text-muted'}`} data-id="element-660" data-mp="3p0bjaa67ku14">
      {problem ?? (saving !== null ? `De klant bespaart ${euro(saving, {
      cents: true
    })} ten opzichte van ${sessions} losse behandelingen. Stopt ze eerder, dan tellen gedane sessies tegen de losse prijs.` : `Alleen als kuur: ${euro(kuurPrice / sessions, {
      cents: true
    })} per sessie. Stopt ze eerder, dan krijgt ze de niet-gebruikte sessies tegen dat tarief terug.`)}
    </p>;
}